.centered {
	height: 100%;
	display: grid;
	place-items: center;
	text-align: center;
}

.dashboard {
	--nav-width: auto;
	height: 100%;
	display: grid;
	grid-template-columns: var(--nav-width) 1fr;

	@media (min-width: 540px) {
		--nav-width: 16rem;
	}

	.nav {
		min-width: max-content;
		min-height: 0;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		gap: var(--size-8);
		/* trims 6px off each end, as the breadcrumbs do off the content's padding, so the switcher lines up with them */
		padding: calc(var(--size-6) - 6px) var(--size-6);
		background-color: light-dark(
			color-mix(in oklab, var(--gray-300), var(--gray-400)),
			color-mix(in oklab, var(--gray-900) 70%, var(--gray-800))
		);
	}

	.content {
		min-width: 0;
		min-height: 0;
		display: flex;
		flex-direction: column;
		gap: var(--size-9);
		padding: var(--size-6) var(--size-9) var(--size-9);
	}

	.navlinks {
		flex: 1;
		animation: nav-enter 0.15s ease-out;
	}

	.main {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		min-height: 0;
	}
}

.orgDropdownItem {
	display: flex;
	align-items: center;
	gap: var(--size-3);
}

.arrow {
	transform-origin: center center;
	transition: transform 0.1s ease;

	:has(+ :popover-open) > & {
		transform: rotate(180deg);
	}
}

@keyframes nav-enter {
	from {
		opacity: 0;
		transform: translateY(var(--size-2));
	}
}
